/* eslint-disable no-undef */
import { appEnv } from "@/constants/env";
import GA4 from "react-ga4";

const initialize = () => {
  GA4.initialize(appEnv.ga4Key);
};

const setDebug = (enabled: boolean) => {
  GA4.gtag("config", appEnv.ga4Key, { debug_mode: enabled });
};

const sendEvent = (name: string, params: any = {}) => {
  GA4.event(name, params);
};

export const analytics = {
  initialize,
  setDebug,
  sendEvent,
};
